import {match} from 'ts-pattern';

import {DrillDownLevelName} from '@dms/api/core';
import i18n from '@dms/i18n';

import {getSafely, Nullish} from 'shared/web';

import {OTHER_LEVEL_VALUE} from '../constants/OTHER_LEVEL_VALUE';
import {LevelConfiguration} from '../types';

const getOtherLabel = () => i18n.t('entity.vehicle.labels.otherLabel');

/**
 * Additional levels appended to the default drill down path.
 * Their values are not catalogue keys, so the row labels are built from the raw value.
 * Default order of the levels is VAT → trim level → number of seats.
 */
export function getOptionalLevelConfigurations(
  hiddenLevels: DrillDownLevelName[] | Nullish
): LevelConfiguration[] {
  const levelConfigurations: LevelConfiguration[] = [
    {
      name: 'vat_reclaimable',
      title: i18n.t('general.labels.vatDeductible'),
      getValueLabel: (value) =>
        match(value)
          .with('true', () => i18n.t('general.labels.yes'))
          .with('false', () => i18n.t('general.labels.no'))
          .otherwise(getOtherLabel),
    },
    {
      name: 'trim_level',
      title: i18n.t('entity.vehicle.labels.trimLevel'),
      // The catalogue label comes in translations, the raw key stays when the catalogue does not know it.
      getValueLabel: (value, translations) =>
        value === OTHER_LEVEL_VALUE ? getOtherLabel() : (getSafely(translations, value) ?? value),
    },
    {
      name: 'number_of_seats',
      title: i18n.t('entity.vehicle.labels.numberOfSeatsFull'),
      getValueLabel: (value) => (value === OTHER_LEVEL_VALUE ? getOtherLabel() : value),
    },
  ];

  return levelConfigurations.filter(
    (levelConfiguration) => !hiddenLevels?.includes(levelConfiguration.name)
  );
}
